<template>
  <router-view />
</template>

<script>
  export default {
    name: 'MultilevelMenuLayout',
  }
</script>
